import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { environment } from '../environments/environment';
import { DailyDosingTableResponse } from '../interfaces/daily-dosing';
import { GetDosingOverrideResponse } from '../interfaces/data-override';

@Injectable({
    providedIn: 'root',
})

export class DataOverrideService {
    baseUrl = environment.baseUrl;
    constructor(private http: HttpClient) { }

    getDataOverrideData(siteId: number, fromDate: string, toDate: string): Observable<GetDosingOverrideResponse[]> {
        var params = new URLSearchParams();
        params.append('siteId', siteId.toString());
        params.append('fromDate', fromDate);
        params.append('toDate', toDate);
        var url = `${this.baseUrl}plantperformanceoverridedata?${params.toString()}`;
        return this.http.get<GetDosingOverrideResponse[]>(url);
    }

    saveDataOverride(payload: any) {
        var url = `${this.baseUrl}plantperformanceoverridedata`;
        return this.http.post<boolean>(url, payload);
    }
}